import React, { useContext, useEffect } from 'react';
import HeaderLayout from './HeaderLayout';
import HeaderCloseButton from './HeaderCloseButton/HeaderCloseButton';
import HeaderMenuToggle from './HeaderMenuToggle/HeaderMenuToggle';
import HeaderTitle from './HeaderTitle/HeaderTitle';
import { ChatbotContext } from '../../../Contexts/ChatbotContext';
import useChatbot from '../../../Hooks/useChatbot';
import NavigationButton from '../../Wizard/NavigationButton/NavigationButton';

function Header() {
  const { isMenuOpen, setIsMenuOpen } = useContext(ChatbotContext);
  const { minimize,  endLiveChat } = useChatbot();



  return (
    <>
      <HeaderLayout>
        <HeaderLayout.MenuToggle>
          <HeaderMenuToggle onClick={() => setIsMenuOpen(!isMenuOpen)} />
        </HeaderLayout.MenuToggle>

        <HeaderLayout.Title>
          <HeaderTitle />
        </HeaderLayout.Title>

        <HeaderLayout.CloseButton>
          <HeaderCloseButton onClick={minimize} />
        </HeaderLayout.CloseButton>
      </HeaderLayout>

   
    </>
  );
}

export default Header;
